import { render, staticRenderFns } from "./StakingSale.vue?vue&type=template&id=7828adae&scoped=true"
import script from "./StakingSale.vue?vue&type=script&lang=js"
export * from "./StakingSale.vue?vue&type=script&lang=js"
import style0 from "./StakingSale.vue?vue&type=style&index=0&id=7828adae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7828adae",
  null
  
)

export default component.exports